const Title = () => {
  return (
    <div className="flex w-full items-center justify-center text-center">
      <p className="text-3xl sm:text-6xl font-bold -mt-10 h-0 sm:h-10 sm:mt-0">
        <span className="bg-gradient-to-r from-brand-purple to-brand-blue text-transparent bg-clip-text sm:h-20 text-3xl sm:text-6xl">
          Choose the plan
        </span>
        &nbsp;that fits your needs
      </p>
    </div>
  );
};

export default Title;
